import axios from "axios";
import { useState } from "react";
import Loading from "src/components/Loading";
import PageHeader from "src/components/PageHeader";
import WhiteBoard from "src/components/WhiteBoard";
import { post } from "src/services/HttpClient";
import { PiDownloadDuotone } from "react-icons/pi";
import { RiFileExcel2Line } from "react-icons/ri";
import { notify } from "src/services/Notification/Notification";
import Hintbox from "src/components/Hintbox";
const moment = require("jalali-moment");

export default function UpdateExcel() {
    const [file, setFile] = useState(null);
    const [isLoading, setIsLoading] = useState(false);

    const handleFileChange = (e) => {
        setFile(e.target.files[0]);
    };

    // عملیات همزمان آپلود و آپدیت دیتابیس (بر اساس ساختار جدید بک‌اند)
    const handleUploadAndUpdate = async (e) => {
        e.preventDefault();
        if (!file) {
            notify("لطفاً ابتدا یک فایل انتخاب کنید!", "error");
            return;
        }

        setIsLoading(true);
        const formData = new FormData();
        formData.append("file", file);

        try {
            // روت مستقیم ماژول جدید اکسل در بک‌اند
            const response = await post("/excel-utility/products/upload", formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            });

            // در HttpClient شما معمولاً داده‌ها به صورت مستقیم یا در پاسخ بازمی‌گردند
            if (response?.success) {
                notify(response.message || "اطلاعات کالاها با موفقیت بروزرسانی شد.");
                setFile(null); // ریست کردن فایل پس از موفقیت
            } else {
                notify(response?.message || "خطا در پردازش فایل", "error");
            }
        } catch (err) {
            console.error(err);
            notify(err?.response?.data?.message || "خطای شبکه، لطفا مجددا امتحان کنید", "error");
        } finally {
            setIsLoading(false);
        }
    };

    // دانلود فایل اکسل (XLSX)
    const handleDownload = async () => {
        try {
            setIsLoading(true);
            const response = await axios.get("/excel-utility/products/download", {
                responseType: "blob",
            });

            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute(
                "download",
                `products-update-${moment().locale("fa").format("jYYYY-jMM-jDD_HH-mm")}.xlsx`
            );
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
        } catch (error) {
            console.error("Error downloading the file:", error);
            notify("خطا در دانلود قالب اکسل محصولات", "error");
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div>
            <PageHeader title="ویرایش محصولات با اکسل" />

            <div className="flex xl:flex-row flex-col gap-4 w-full">
                {/* بخش دانلود */}
                <div className="w-full">
                    <WhiteBoard className="!p-10">
                        <div className="w-full flex justify-center items-center mb-4">
                            <PiDownloadDuotone size={60} className="text-primary-color" />
                        </div>
                        <Hintbox text="برای دانلود لیست بروز تمامی محصولات بر روی دکمه زیر کلیک کرده و لطفا چند لحظه منتظر بمانید" />
                        <div className="flex justify-center items-center mt-6">
                            <button
                                className="dark:bg-gray-700 bg-gray-100 w-fit p-4 py-3 rounded-lg hover:text-white hover:bg-primary-color transition-all ease-in-out duration-200 cursor-pointer h-[48px] font-medium"
                                onClick={handleDownload}
                            >
                                دانلود خروجی محصولات (Excel)
                            </button>
                        </div>
                    </WhiteBoard>
                </div>

                {/* بخش آپلود و پردازش فوری */}
                <div className="w-full">
                    <WhiteBoard className="!p-10">
                        <div className="w-full flex justify-center items-center mb-4">
                            <RiFileExcel2Line size={60} className="text-green-600" />
                        </div>
                        <Hintbox text="برای بروزرسانی سریع، فایلی را که دانلود کرده‌اید ویرایش کنید و پس از ذخیره، فیلدهای تغییر یافته را مستقیماً آپلود کنید." />

                        <form onSubmit={handleUploadAndUpdate} className="flex flex-col justify-center items-center gap-6 mt-6 w-full">
                            <input 
                                type="file" 
                                accept=".xlsx" 
                                onChange={handleFileChange} 
                                className="block w-full text-sm text-gray-500 file:mr-4 file:py-2 file:px-4 file:rounded-md file:border-0 file:text-sm file:font-semibold file:bg-gray-100 dark:file:bg-gray-700 file:text-gray-700 dark:file:text-gray-200 hover:file:bg-gray-200 cursor-pointer"
                            />
                            
                            <button
                                className="dark:bg-gray-700 bg-gray-100 w-full sm:w-1/2 p-4 py-3 rounded-lg hover:text-white hover:bg-primary-color transition-all ease-in-out duration-200 cursor-pointer h-[48px] font-medium flex justify-center items-center"
                                type="submit"
                                disabled={isLoading}
                            >
                                <span>بروزرسانی</span>
                            </button>
                        </form>
                    </WhiteBoard>
                </div>
            </div>

            {isLoading && <Loading title="در حال انجام عملیات، لطفا منتظر بمانید..." />}
        </div>
    );
}